import React from 'react';
import isEqual from "lodash/isEqual";
import qs from "qs";

const ScrollTop = (Component) => {

  class HOComponent extends React.Component {

    componentDidMount() {
      document.querySelector('.devent-content').scrollTop = 0;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      const thisParams = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
      const prevParams = qs.parse(prevProps.location.search, {ignoreQueryPrefix: true});
      if(!isEqual(thisParams, prevParams)){
        document.querySelector('.devent-content').scrollTop = 0;
      }
    }

    render() {
      return <Component { ...this.props } />
    }
  }

  return HOComponent;
};

export default ScrollTop;
